import { attributesToProps } from 'html-react-parser';
import { Link } from '@/app_components/common/Link';
import { renderChild } from '@/app_lib/htmlParser/parsers/parserOptions';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';

export const LinkParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { href, className } = props;
  return (
    <Link
      className={cn(className)}
      href={href?.toString() || ''}
      prefetch={false}
      {...props}
    >
      {renderChild(children)}
    </Link>
  );
};
